import { use, useState } from 'react';
import { type ListDropdownItem } from '@sr/types';
import { Chevron, colors, Paragraph } from 'component-library';
import { DropdownContexts } from '../../../context/DropdownContext';
import {
  ChevronWrapper,
  IconButtonStyled,
  IconWrapper,
  ListWrapper,
  SimpleListItemWrapper,
} from '../style';
import { ListItemSelectSimple } from '../components/ListItemSelectSimple';

export type HierarchySelectListItem = {
  description?: string;
  dwKey: string;
};

export const HierarchySelectList = () => {
  const { items } = use(DropdownContexts.useItems);

  const values = use(DropdownContexts.useValues);
  const { selectedItems } = values;
  const { searchActive, searchResults } = use(DropdownContexts.useSearch);

  const itemsToRender = searchActive ? searchResults : items;

  return (
    <ListWrapper>
      <InnerHierarchySelectList items={itemsToRender} selectedValues={selectedItems} />
    </ListWrapper>
  );
};

type HierarchySelectListProps = {
  items: ListDropdownItem[];
  selectedValues: string[];
  nestedIndex?: number;
};
const InnerHierarchySelectList = ({
  items,
  selectedValues,
  nestedIndex = 1,
}: HierarchySelectListProps) => {
  return (
    <>
      {items.map((item) => {
        return (
          <HierarchySelectListItem
            key={item.value + item.label}
            item={item}
            selectedValues={selectedValues}
            nestedIndex={nestedIndex}
          />
        );
      })}
    </>
  );
};

const HierarchySelectListItem = ({
  item,
  selectedValues,
  nestedIndex,
}: {
  item: ListDropdownItem<HierarchySelectListItem>;
  selectedValues: string[];
  nestedIndex: number;
}) => {
  const [expanded, setExpanded] = useState(false);
  const isSelected = selectedValues.includes(item.value);
  const hasChildren = item.children.length > 0;

  return (
    <>
      <ListItemSelectSimple key={item.value + item.label} item={item} nestedIndex={nestedIndex}>
        <SimpleListItemWrapper isSelected={isSelected} showBold={hasChildren}>
          <span>{item.label}</span>
          <Paragraph variant="medium" color={colors.primary.grey}>
            {item.meta?.description && item.meta.description}
          </Paragraph>
        </SimpleListItemWrapper>
        {hasChildren && (
          <IconWrapper>
            <ChevronWrapper
              onClick={(e) => {
                setExpanded(!expanded);
                e.stopPropagation();
              }}
            >
              <IconButtonStyled
                variant="secondary"
                onClick={() => {
                  setExpanded(!expanded);
                }}
              >
                <Chevron height="24px" width="24px" rotation={expanded ? 180 : 0} />
              </IconButtonStyled>
            </ChevronWrapper>
          </IconWrapper>
        )}
      </ListItemSelectSimple>
      {hasChildren && expanded && (
        <InnerHierarchySelectList
          items={item.children}
          selectedValues={selectedValues}
          nestedIndex={nestedIndex + 1}
        />
      )}
    </>
  );
};
